<template>
  <div class="card-address">
    <div class="address-item">
      <!-- 收货地址：空的 -->
      <div class="item-text title" v-if="isEmpty">
        填写地址信息
        <div class="tips">不包括港澳台和海外</div>
      </div>
      <!-- 收货地址：姓名、电话 -->
      <div class="item-text" v-else>
        <span>
          <span class="default" v-if="address.defaultMark">默认</span>
          <span class="tips">{{ addressArea.p }}</span>
          <span class="tips" v-if="addressArea.p != addressArea.c">{{ addressArea.c }}</span>
          <span class="tips">{{ addressArea.a }}</span>
        </span>
      </div>
      <div class="item-text title has-detail" v-if="!isEmpty">
        {{ address.addressDetail }}
      </div>
      <div class="item-text tit" v-if="!isEmpty">
        <span class="is-name">{{ address.contactName }}</span>
        <span class="is-name">{{ address.contactNo }}</span>
      </div>
    </div>
    <!-- <iconfont class="iconmore" /> -->
  </div>
</template>

<script>
export default {
  name: 'CardAddress',
  data() {
    return {}
  },
  props: ['address'],
  computed: {
    isEmpty() {
      return !this.address.contactName
    },
    addressArea() {
      const [p, c, a] = this.isEmpty ? [] : this.address.addressArea.split(' / ')
      return { p, c, a }
    }
  },
  methods: {
    // 选择设置地址
    setAddress() {
      const orderId = this.$route.params.id
      this.$router.push({
        name: this.isEmpty ? 'addressPush' : 'addressList',
        query: { orderId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.38rem 0.48rem;
  background-color: #fff;
  .address-item {
    flex: 1;
    text-align: left;
    font-size: 0.32rem;
    line-height: 0.4rem;
    .item-text {
      padding: 0 3px;
      color: #666666;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      .default {
        font-size: 0.2rem;
        color: #00b25a;
        background-color: #d7e7e7;
        padding: 0.04rem 0.08rem;
        margin-right: 0.08rem;
        border-radius: 0.04rem;
      }
      // 标题
      &.title {
        font-weight: bold;
      }
      // 标题
      &.tit {
        font-size: 0.28rem;
        color: #333333;
      }
      // 详情地址
      &.has-detail {
        line-height: 0.5rem;
        margin: 0.16rem 0;
        font-size: 0.36rem;
        color: #000000;
      }
      // 信息
      .is-name {
        padding-right: 0.16rem;
      }
      // 信息标签
      .tips {
        margin-top: 0.16rem;
        font-size: 0.24rem;
        line-height: 0.3rem;
        color: #999999;
      }
    }
  }
}
</style>
